// ============ plugin import ============ //
import React from 'react'
// ============ component import ============= //
import InformationItem from './component/othersSetup/InformationItem';

const Step2 = (props) => {
    const {
        formValidateError,
        formData,
    } = props;
    return (
        <>
            <InformationItem
                formData={formData}
                formValidateError = {formValidateError}
                onInputChange={props.onInputChange}
                isInfoOpenHandler={props.isInfoOpenHandler}
            />
        </>
    )
}

export default Step2